import React from 'react';
import { Link } from 'react-router-dom';
import '../styles//Dropdown.css';

const Dropdown = () => {
  return (
    <ul className="dropdown">
      <li><Link to="/team">Team</Link></li>
      <li><Link to="/testimonials">Testimonials</Link></li>
    </ul>
  );
};

export default Dropdown;